import moment from "moment";
import React, { useEffect, useState } from "react";
import { Button, ButtonGroup } from "reactstrap";
import {
  getStudentDetails,
  getStudentInvoices,
  getStudentPrograms,
  updateStudentInformation,
} from "../../actions/emActions";
import { imageLink } from "../../actions/utility";
import emptyImage from "../../public/images/empty.svg";
import "../educationMamaComponents/StudentDetails/studentDetails.scss";
import CoursesDetails from "../educationMamaComponents/StudentDetails/CoursesDetails";
import Invoices from "../educationMamaComponents/StudentDetails/Invoices";
import ReferralTo from "../educationMamaComponents/StudentDetails/ReferralTo";
import { withRouter } from "react-router-dom";
import Snackbar from "../Snackbar";

const StudentProfileView = (props) => {
  const [studentInfo, setstudentInfo] = useState([]);
  const [userName, setuserName] = useState("");
  const [firstName, setfirstName] = useState("");
  const [lastName, setlastName] = useState("");
  const [email, setemail] = useState("");
  const [phoneNumber, setphoneNumber] = useState("");
  const [loginName, setloginName] = useState("");
  const [activeTab, setactiveTab] = useState(3);
  const [programData, setprogramData] = useState([]);
  const [allInvoices, setallInvoices] = useState({});
  const [snackbarMessage, setsnackbarMessage] = useState("");
  const [snackbarColor, setsnackbarColor] = useState("#01ac8a");
  const [referralCount, setreferralCount] = useState("");
  useEffect(() => {
    getStudentDetails(2, props.studentid).then((res) => {
      setstudentInfo(res.data);
      setfirstName(res.data.lm_candidate_profile[0].first_name);
      setlastName(res.data.lm_candidate_profile[0].last_name);
      setemail(res.data.user_email);
      setuserName(res.data.user_name);
      setloginName(res.data.user_loginname);
      setphoneNumber(res.data?.lm_candidate_profile[0].phone);
      setreferralCount(res?.data?.referral_count);
    });

    getStudentPrograms(props.studentid).then((res) => {
      setprogramData(res.data);
    });

    getStudentInvoices(props.studentid).then((res) => {
      setallInvoices(res.data);
    });
  }, []);

  // const numberOfPrograms = programData?.filter(
  //   (item) => item.status === 1
  // ).length;
  let prog_ids = programData
    ?.filter((program) => program.is_expired === 0)
    ?.map((x) => x.prog_id);
  const numberOfPrograms = [...new Set(prog_ids)]?.length;
  // console.log([...new Set(prog_ids)].length);
  const StudentfirstName = studentInfo?.lm_candidate_profile?.[0]["first_name"];

  const snackBarFunction = () => {
    var x = document.getElementById("snackbar");
    x.className = "show";
    setTimeout(function () {
      x.className = x.className.replace("show", "");
    }, 3000);
  };

  const updateInfo = () => {
    updateStudentInformation(
      props.studentid,
      userName,
      email,
      phoneNumber
    ).then((res) => {
      if (res?.status === 200) {
        debugger;
        setsnackbarMessage("Information Updated Successfully!");
        setsnackbarColor("#01ac8a");
        snackBarFunction();
        window.location.reload();
      } else {
        setsnackbarMessage("Some Error Occurred!");
        setsnackbarColor("#E61610");
        snackBarFunction();
      }
    });
  };
  return (
    <div>
      <Snackbar msg={snackbarMessage} color={snackbarColor} />
      <div className="AllStudensComponent text-left">
        {/* <HeaderComponent /> */}
        <div style={{ padding: "2vh 0" }}>
          <div className="">
            <div className="row">
              {/* <div className="col-md-3">
                <RightSectionEM />
              </div> */}

              <div className="col-md-12 studentDetails mb-5">
                <div className="cover"></div>
                <div className="container">
                  <div className="row">
                    <div className="col-md-2">
                      <img
                        className="roundedAvatarOverlay"
                        src={
                          studentInfo.image !== null
                            ? imageLink(studentInfo.image)
                            : emptyImage
                        }
                      />
                    </div>
                    <div className="col-md-10">
                      <div className="d-block d-md-flex ml-3 justify-content-between marginOnMobile80Px">
                        <div>
                          <label className="userName mb-0">
                            {studentInfo.user_name}{" "}
                          </label>
                          <br />
                          <label className="generalText mb-0">
                            {" "}
                            <i className="fa fa-envelope mr-2 iconColor"></i>
                            {studentInfo.user_email}
                          </label>
                          <br />
                          <label className="generalText mb-0">
                            <i className="fa fa-phone mr-2 iconColor"></i> +
                            {studentInfo?.lm_candidate_profile?.[0]["phone"]}
                          </label>
                          <br />
                          <label className="generalText mb-0">
                            <i className="fa fa-graduation-cap mr-1 iconColor"></i>{" "}
                            {numberOfPrograms} Courses{" "}
                          </label>
                          <br />
                          <label className="generalText">
                            <i className="fa fa-money mr-1 iconColor"></i>{" "}
                            <span className="text-danger">
                              {" "}
                              Rs {allInvoices.unpayedAmount} Due
                            </span>{" "}
                          </label>
                        </div>
                        <div className="my-auto">
                          <label className="generalText">
                            <i className="fa fa-clock-o mr-1 iconColor"></i>{" "}
                            Since {moment(studentInfo.ts).format("Do MMM 'YY")}
                          </label>

                          <div>
                            {studentInfo?.siblings?.length > 0 && (
                              <label className="mb-0">
                                {StudentfirstName}'s siblings:
                              </label>
                            )}
                            {studentInfo?.siblings &&
                              studentInfo?.siblings.map(
                                (siblings, index) =>
                                  index < 2 && (
                                    // <Link
                                    //   to={`/${siblings.id}/invoices/21312321`}>
                                    <div
                                      className="siblingsImg mt-1 d-flex"
                                      onClick={() => {
                                        props.history.push(
                                          `/${siblings.id}/invoices/21312321`
                                        );
                                        window.location.reload();
                                      }}
                                    >
                                      <div className="smallAvatar">
                                        <img
                                          src={
                                            siblings.image !== null
                                              ? imageLink(siblings.image)
                                              : emptyImage
                                          }
                                          className=""
                                        />
                                      </div>

                                      <div>
                                        <label className="generalText ml-2 mt-2">
                                          <span className="text-primary">
                                            {siblings.user_name}
                                          </span>
                                        </label>
                                      </div>
                                    </div>
                                    // </Link>
                                  )
                              )}
                          </div>
                          {/* <div>
                            <div className="siblingsImg mt-1 d-flex">
                              <div className="smallAvatar">
                                <img
                                  src="https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/lmprofile_1594283790_up_547807745.jpeg"
                                  className=""
                                />
                              </div>
                              <div className="smallAvatar">
                                <img
                                  src="https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/lmprofile_1653543466_up_98372113.jpeg"
                                  className=""
                                />
                              </div>
                              <div>
                                <label className="generalText ml-2 mt-2">
                                  <span className="text-primary">Maraib</span> &{" "}
                                  <span className="text-primary">Zaimal</span>
                                  &nbsp;are siblings of Inara.
                                </label>
                              </div>
                            </div>
                          </div> */}
                        </div>
                        <div className="my-auto">
                          {/* <a target="__blank" href={`/#/${studentInfo?.hashId}`}> */}
                          <button
                            className="goToFeeds"
                            onClick={() => {
                              window.open(
                                `/#/${studentInfo?.hashId}`,
                                "_blank"
                              );
                            }}
                          >
                            {StudentfirstName}'s feeds{" "}
                            <i className="fa fa-arrow-right "></i>
                          </button>
                          {/* </a> */}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <div className="tabSection">
                        <ButtonGroup>
                          <Button
                            onClick={() => setactiveTab(1)}
                            className={
                              activeTab === 1
                                ? "tabsButtonActive"
                                : "tabsButton"
                            }
                          >
                            Personal
                          </Button>
                          <Button
                            onClick={() => setactiveTab(2)}
                            className={
                              activeTab === 2
                                ? "tabsButtonActive"
                                : "tabsButton"
                            }
                          >
                            Courses
                          </Button>
                          <Button
                            onClick={() => setactiveTab(3)}
                            className={
                              activeTab === 3
                                ? "tabsButtonActive"
                                : "tabsButton"
                            }
                          >
                            Invoices
                          </Button>
                          <Button
                            onClick={() => setactiveTab(4)}
                            className={
                              activeTab === 4
                                ? "tabsButtonActive"
                                : "tabsButton"
                            }
                          >
                            Referral Details
                          </Button>
                        </ButtonGroup>
                      </div>

                      <div className="tabsContentData p-3">
                        {activeTab === 1 ? (
                          <div>
                            <div className="row">
                              <div className="col-md-4">
                                <div>
                                  <label className="fieldLabel">
                                    Full name:
                                  </label>
                                  <br />
                                  <input
                                    value={userName}
                                    placeholder=""
                                    className="studentField"
                                    type="text"
                                    onChange={(e) =>
                                      setuserName(e.target.value)
                                    }
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="row mt-2">
                              <div className="col-md-4">
                                <div>
                                  <label className="fieldLabel">Email:</label>
                                  <br />
                                  <input
                                    value={email}
                                    placeholder=""
                                    className="studentField"
                                    type="email"
                                    onChange={(e) => setemail(e.target.value)}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="row mt-2">
                              <div className="col-md-4">
                                <div>
                                  <label className="fieldLabel">
                                    Contact number:
                                  </label>
                                  <br />
                                  <input
                                    value={phoneNumber}
                                    placeholder=""
                                    className="studentField"
                                    type="text"
                                    onChange={(e) =>
                                      setphoneNumber(e.target.value)
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                            {/* <div className="row mt-2">
                              <div className="col-md-4 mt-2">
                                <div>
                                  <label className="fieldLabel">Login Name:</label>
                                  <br />
                                  <input
                                    value={loginName}
                                    placeholder=""
                                    className="studentField"
                                    type="text"
                                  />
                                </div>
                              </div>
                            </div> */}
                            {/* <div className="row mt-2">
                              <div className="col-md-4 mt-2">
                                <div>
                                  <label className="fieldLabel">Password:</label>
                                  <br />
                                  <input placeholder="" className="studentField" type="text" />
                                </div>
                              </div>
                            </div> */}
                            <div className="row mt-2">
                              {/* <div className="col-md-4 mt-2">
                                <div>
                                  <label className="fieldLabel">Notes:</label>
                                  <br />
                                  <textarea placeholder="" className="studentField" type="text" />
                                </div>
                              </div> */}
                              <div className="col-md-12 text-right my-auto">
                                <div className="" onClick={() => updateInfo()}>
                                  <button className="saveBtn">
                                    Update Information
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : activeTab === 2 ? (
                          <CoursesDetails
                            studentsProgram={programData}
                            studentId={props.studentid}
                          />
                        ) : activeTab === 3 ? (
                          <Invoices studentId={props.studentid} />
                        ) : (
                          <ReferralTo
                            studentId={props.studentid}
                            studentName={StudentfirstName}
                            referralCount={referralCount}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(StudentProfileView);
